// extracted by mini-css-extract-plugin
module.exports = {"overlay":"MobileMenu_overlay__Zabpg","menu":"MobileMenu_menu__3mRA6","headerMenu":"MobileMenu_headerMenu__15YA3"};